import { components } from "@/api-schema";
import { automaticCellRenderer } from "@/components/data-table/_helpers/cell-renderer";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { EmptyValue } from "@/components/ui/empty-value";
import { getJobFunctionV1Identifier } from "@/modules/masterdata/job-function/job-function-identifiers";
import i18next from "i18next";
import { commonColumns } from "./_constants/common-columns";

export type JobFunctionTableType = components["schemas"]["JobFunction"];

export const jobFunctionTableDefaultColumns = {
  columnName: commonColumns.columnName<JobFunctionTableType>(),
  columnTechnicalId: commonColumns.columnTechnicalId<JobFunctionTableType>(),
  columnDeletedAt: commonColumns.columnDeletedAt<JobFunctionTableType>(),
  columnUuid: commonColumns.columnUuid<JobFunctionTableType>(),
  columnV1Id: {
    id: "v1Id",
    size: 50,
    enableSorting: false,
    align: "right",
    header: () => i18next.t("masterdata:V1ID"),
    visibility: [],
    accessorFn: (row: JobFunctionTableType) => getJobFunctionV1Identifier(row),
    cell: (cell) => {
      const v1Identifier = cell.getValue();
      return v1Identifier ? automaticCellRenderer(v1Identifier) : <EmptyValue />;
    },
  } as ImplementedAccessorColumnDef<JobFunctionTableType, string | undefined>,
  columnCreatedAt: commonColumns.columnCreatedAt<JobFunctionTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<JobFunctionTableType>(),
};
